import { useState } from "react";
import { className } from '../../../../Utils';

import AccordionHeader from "./AccordionHeader";
import AccordionContentDesktop from "./AccordionContentDesktop";
import AccordionVideo from "./AccordionVideo";

import "./Accordion.css";

const Accordion = ({ data, title, videoUrl, freeFunctionality, isOpen, setOpenAccordion, id }) => {
    const [isOpenVideo, setIsOpenVideo] = useState(false);
    const [clicked, setClicked] = useState(false);

    const toggle = index => {
        if (clicked === index) {
            return setClicked(null);
        }
        setClicked(index);
    };

    return (
        <main>
            <div className={className("container")}>
                <div className={className('container-accordion-video-wrapper')}>
                    <AccordionVideo
                        videoUrl={videoUrl}
                        isOpenVideo={isOpenVideo}
                        SetIsOpenVideoHandler={setIsOpenVideo}
                        title={title}
                    />
                </div>

                <section className={className('info')}>
                    <AccordionHeader
                        title={title}
                        SetIsOpenVideoHandler={setIsOpenVideo}
                        setOpenAccordion={setOpenAccordion}
                        data={data}
                        freeFunctionality={freeFunctionality}
                        videoUrl={videoUrl}
                        isOpen={isOpen}
                        id={id}
                        toggle={toggle}
                        clicked={clicked}
                    />

                    {isOpen && (
                        <div>
                            {data.map((item, index) => (
                                <AccordionContentDesktop
                                    key={`accordion-${index}`}
                                    itemTitle={item.title}
                                    content={item.content}
                                    freeFunctionality={freeFunctionality}
                                />
                            ))}
                        </div>
                    )}
                </section>
            </div>
        </main>
    );
};


export default Accordion;